export default __webpack_public_path__ + "static/hanDAO@2x-1ee587e6c109f78a852498037c3f8b8c.jpg";